import { render, staticRenderFns } from "./ClaimLogsCard.vue?vue&type=template&id=f2d269a4&scoped=true&lang=pug&"
import script from "./ClaimLogsCard.vue?vue&type=script&lang=js&"
export * from "./ClaimLogsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d269a4",
  null
  
)

export default component.exports